export const routes = {
  ADMIN: '/admin',
  ADMIN_COMPANY: '/admin/company',
  ADMIN_USERS: '/admin/users',
  ADMIN_USER_NEW: '/admin/users/new',
  ADMIN_USER_EDIT: '/admin/users/:id',
  DEMO_MIGRATION: '/admin/demo-migration',
  ADMIN_COMPANY_EDIT: '/admin/company/:id',
  ADMIN_COMPANY_PERMISSION: '/admin/company/:id/permission',
  ADMIN_COMPANY_PERMISSION_EDIT: '/admin/company/:id/permission/:permissionId',
  ADMIN_CREATE_USER: '/admin/create-user',
  ANALYTICS: '/analytics',
  DEMO: '/d',
  DEMO_ANALYTICS: '/analytics/recording',
  DEMO_LIST: '/minhas-demos',
  DEMOHUB: '/h',
  DEMOHUB_LIST: '/demohubs',
  DEMOHUB_EDITOR: '/demohubs/editor',
  DEMOHUB_EDITOR_NEW: '/demohubs/editor/new',
  DEMOHUB_PREVIEW: '/demohubs/preview',
  DEMOHUB_ANALYTICS: '/analytics/demohub',
  EDIT_FORM: '/formularios/editar',
  EDIT_STORYLINE: '/minhas-storylines/editar',
  FEDERATED_SIGN_IN_CALLBACK: '/sign-in-callback',
  FEEDBACK_FORGOT_PASSWORD: '/esqueci-minha-senha-sucesso',
  FEEDBACK_NEW_PASSWORD: '/nova-senha-sucesso',
  FEEDBACK_NEW_VIEWER_USER_PASSWORD: '/confirmar-usuario-sucesso',
  FORM: '/formularios',
  FORGOT_PASSWORD: '/esqueci-minha-senha',
  HOME: '/',
  HUBSPOT: '/hubspot',
  ZENDESK: '/zendesk',
  OUTREACH: '/outreach',
  RDSTATION: '/rdstation',
  RDSTATION_MKT: '/rdstation-mkt',
  INTEGRATIONS: '/integracoes',
  INTEGRATIONS_MODULE: '/integracoes/:module',
  INTEGRATIONS_DEMOS: '/integracoes/demos',
  INTEGRATIONS_AGENTES: '/integracoes/agentes',
  INTEGRATIONS_GUIAS: '/integracoes/guias',
  N8N_INTEGRATION: '/integracoes/n8n',
  MCP_INTEGRATION: '/integracoes/assistentes-de-ia',
  NEW_FORM: '/formularios/nova',
  NEW_PASSWORD: '/nova-senha',
  NEW_USER: '/novo-usuario',
  NEW_AVATAR: '/novo-avatar',
  NEW_VIEWER_USER_PASSWORD: '/confirmar-usuario',
  PIPEDRIVE: '/pipedrive',
  GOOGLE: '/google',
  MICROSOFT: '/microsoft',
  PREVIEW: '/preview',
  PREVIEW_STORYLINE: '/preview-storyline',
  SALESFORCE: '/salesforce',
  SALESFORCE_STAGING: '/salesforce-staging',
  SETUP: '/configuracoes',
  SINGLE_SIGN_IN_CALLBACK: '/sso-callback',
  SLACK: '/slack',
  MAKE: '/make',
  // Prefix of the MCP OAuth pages in the panel; the MCP endpoint itself is on the API host.
  MCP: '/mcp',
  MCP_AUTHORIZE: '/mcp/autorizar',
  STORYLINE: '/minhas-storylines',
  STORYLINE_ANALYTICS: '/analytics/storyline',
  STORYLINE_PLAYER: '/s',
  TEAM: '/time',
  AVATAR: '/avatar',
  BOT: '/bot',
  NEW_BOT: '/novo-bot',
  BOT_PLAYER: '/b',
  BOT_PREVIEW: '/b/:id/preview',
  BOT_LEADS: '/bot/interactions',
  BOT_LEAD_DETAIL: '/bot/interactions/:id',
  BOT_ATTENDANCE: '/bot/atendimento',
  BOT_FLOWS: '/bot/fluxos',
  BOT_METRICS: '/bot/indicadores',
  CAPTURES: '/bot/fluxos/capturas',
  CAPTURE_NEW: '/bot/fluxos/capturas/nova',
  API_DOCS: '/docs',
  GUIDE_PLAYER: '/t',
  CHECKLIST_PLAYER: '/cl',
  GUIDE_LIST: '/meus-guias',
  AUTO_DEPLOY: '/auto-deploy',
  AUTO_DEPLOY_WORKFLOWS: '/auto-deploy/workflows',
  AUTO_DEPLOY_AUTHENTICATIONS: '/auto-deploy/autenticacoes',
  FLOW_PROFILE: '/fluxos',
  GUIDE_ANALYTICS: '/meus-guias/analytics/guia',
  CHECKLIST_ANALYTICS: '/meus-guias/analytics/checklist',
  POPUP_ANALYTICS: '/meus-guias/analytics/popup',
  GUIDE_USER_DETAIL: '/meus-guias/usuarios/:id',
  PREVIEW_GUIDE: '/preview-guide',
  SURVEY_ANALYTICS: '/surveys/analytics/survey',
  NEW_SURVEY: '/surveys/new',
  EDIT_SURVEY: '/surveys/edit',
  NEW_CHECKLIST: '/checklists/new',
  EDIT_CHECKLIST: '/checklists/edit',
  NEW_POPUP: '/popups/new',
  EDIT_POPUP: '/popups/edit',
  HOTSPOT_LIST: '/meus-guias?tab=hotspots',
  HOTSPOT_EDITOR: '/hotspots/edit',
  HOTSPOT_PLAYER: '/hs',
  BANNER_LIST: '/meus-guias?tab=banners',
  NEW_BANNER: '/banners/new',
  EDIT_BANNER: '/banners/edit',
  NEW_BANNER_TEMPLATE: '/banners/templates/new',
  EDIT_BANNER_TEMPLATE: '/banners/templates/edit',
  BANNER_ANALYTICS: '/meus-guias/analytics/banner',
  BANNER_PLAYER: '/bn',
  SEGMENTATION_LIST: '/segmentations',
  UNIFIED_INSTALL: '/instalacao',
  NEW_SEGMENTATION: '/segmentations/new',
  EDIT_SEGMENTATION: '/segmentations/edit',
  SETTINGS: '/configuracoes',
  SELECT_CAPTURE_PURPOSE: '/selecionar-finalidade-captura',
  SANDBOX_LIST: '/sandboxes',
  SANDBOX_NEW: '/sandboxes/nova',
  SANDBOX_FRAME_SELECTOR: '/sandboxes/nova/selecionar-frames',
  SANDBOX_EDIT: '/sandboxes/:id',
  SANDBOX_PREVIEW: '/sandboxes/preview/:id',
  SANDBOX_FLOWCHART: '/sandboxes/:id/fluxograma',
  SANDBOX_PLAYER: '/sb',
  UPLOAD_BASE: '/meus-guias/upload-base',
  GUIDE_USAGE: '/meus-guias/consumo',
  WEBHOOK_LIST: '/webhooks',
  NEW_WEBHOOK: '/webhooks/nova',
  EDIT_WEBHOOK: '/webhooks/editar/:id'
};
